import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Form, Button, Row, Col, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { register, logout } from '../actions/userActions.js'
import FormContainer from '../components/FormContainer.js'
import { USER_REGISTER_RESET } from '../constants/userConstants.js'

const RegisterScreen = ({ history }) => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  // const [message, setMessage] = useState(null)

  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })

  function showAlert(message, variant = 'success', seconds = 2000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inputRef = useRef()

  const userRegister = useSelector((state) => state.userRegister)
  const { loading, error, success, userInfo } = userRegister

  useEffect(() => {
    if (userInfo && !loading) {
      dispatch(logout())
      navigate('/login')
    } else {
      dispatch({ type: USER_REGISTER_RESET })
      inputRef.current.focus()
    }
  }, [navigate, userInfo, dispatch, loading, success])

  const submitHandler = (e) => {
    e.preventDefault()

    if (password !== confirmPassword) {
      showAlert('Passwords do not match', 'danger')
    } else if (password.length < 6) {
      showAlert('Password must be at least 6 characters', 'warning')
    } else {
      dispatch(register(name, email, password))
    }
  }

  return (
    <FormContainer>
      <h3 className='my-2'>User Sign Up</h3>
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {error && <Alert variant='danger'>{error}</Alert>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group className='mb-2' controlId='name'>
          <Form.Label>Name</Form.Label>
          <Form.Control
            ref={inputRef}
            type='name'
            autoFocus
            placeholder='Enter Name'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type='email'
            placeholder='Enter email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='password'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Enter Password (minimum 6 characters)'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-2' controlId='confirmPassword'>
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Confirm Password (minimum 6 characters)'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </Form.Group>

        <Button type='submit' className='btn btn-primary mt-3'>
          Register
        </Button>
      </Form>

      <Row className='py-2'>
        <Col>
          Have an account? <Link to={'/login'}> Login Here</Link>
        </Col>
      </Row>
    </FormContainer>
  )
}

export default RegisterScreen
